import React, { useState, useEffect } from 'react';
import { Label } from 'reactstrap';
import styled from 'styled-components';
import Select from 'react-select';
import _ from 'lodash';

const MonthSelect = ({ setQuery, currentMonth }) => {
  const monthData = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "Aug",
    "09": "Sept",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec",
  };

  // Sort months in the correct order (Jan to Dec)
  const monthOptions = _.map(
    Object.keys(monthData).sort((a, b) => parseInt(a) - parseInt(b)),
    (monthNumber) => ({
      label: monthData[monthNumber],
      value: monthNumber,
    })
  );

  // Find the correct initial month option
  const defaultMonth = monthOptions.find((m) => m.value === currentMonth) || null;

  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);

  useEffect(() => {
    setSelectedMonth(defaultMonth);
  }, [currentMonth]); // Update if `currentMonth` changes

  const handleSelect = (selectedOption) => {
    setSelectedMonth(selectedOption);
    if (setQuery) {
      setQuery(selectedOption?.value);
    }
  };

  return (
    <Flex className='ml-2 ml-md-2'>
      <form className="d-flex" style={{ width: '100%' }}>
        <Select
          options={monthOptions}
          value={selectedMonth}
          onChange={handleSelect}
          className="select"
          placeholder="Select Month"
        />
        <Label className="ml-2 mt-2">{new Date().getFullYear()}</Label>
      </form>
    </Flex>
  );
};

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  .select {
    min-width: 200px;
  }
`;

export default MonthSelect;
